/* header-mega.js - desktop mega menu interactions
   - Hover open with 250ms delay (no accidental triggers on cursor pass-through)
   - Click toggle for keyboard / touch
   - Left-rail tab swap (mouseover or click)
   - ESC to close
   - Click-outside to close
*/
(function () {
  'use strict';

  const HOVER_OPEN_DELAY = 250;
  const HOVER_CLOSE_DELAY = 180;

  const items = document.querySelectorAll('[data-mega]');
  if (!items.length) return;

  let openItem = null;

  function openMega(item) {
    if (openItem && openItem !== item) closeMega(openItem);
    item.setAttribute('data-open', '');
    const panel = item.querySelector('[data-mega-panel]');
    const toggle = item.querySelector('[data-mega-toggle]');
    if (panel) {
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
    }
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    openItem = item;
  }

  function closeMega(item) {
    if (!item) return;
    item.removeAttribute('data-open');
    const panel = item.querySelector('[data-mega-panel]');
    const toggle = item.querySelector('[data-mega-toggle]');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      // Defer hidden until transition completes so the fade-out is visible
      setTimeout(() => {
        if (!item.hasAttribute('data-open')) panel.setAttribute('hidden', '');
      }, 220);
    }
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
  }

  items.forEach((item) => {
    let openTimer, closeTimer;
    const toggle = item.querySelector('[data-mega-toggle]');
    const panel = item.querySelector('[data-mega-panel]');
    if (!toggle || !panel) return;

    item.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => openMega(item), HOVER_OPEN_DELAY);
    });
    item.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => closeMega(item), HOVER_CLOSE_DELAY);
    });

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (item.hasAttribute('data-open')) closeMega(item);
      else openMega(item);
    });

    // Left-rail tabs
    const tabs = panel.querySelectorAll('[data-panel-trigger]');
    const panes = panel.querySelectorAll('[data-panel-content]');
    tabs.forEach((tab) => {
      const switchTo = (idx) => {
        tabs.forEach((t) => {
          const active = t.dataset.panelTrigger === String(idx);
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', String(active));
        });
        panes.forEach((p) => {
          const active = p.dataset.panelContent === String(idx);
          if (active) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      };
      tab.addEventListener('mouseenter', () => switchTo(tab.dataset.panelTrigger));
      tab.addEventListener('focus', () => switchTo(tab.dataset.panelTrigger));
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        switchTo(tab.dataset.panelTrigger);
      });
    });
  });

  // ESC to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openItem) {
      const item = openItem;
      closeMega(item);
      const toggle = item.querySelector('[data-mega-toggle]');
      if (toggle) toggle.focus();
    }
  });

  // Click outside to close
  document.addEventListener('click', (e) => {
    if (!openItem) return;
    if (!openItem.contains(e.target)) closeMega(openItem);
  });
})();
